import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';

// SERVICES
import { AuthGuard } from './guards/auth.guard';
import { ConfirmService } from './services/app-confirm/confirm.service';
import { RoutePartsService } from './services/route-parts.service';

import { FormlyModule } from '@ngx-formly/core';
import { FileUploadComponent } from '../form/components/file-upload/file-upload.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedComponentsModule } from './components/shared-components.module';
import { RouterModule } from '@angular/router';
import { BottomSheetDraggableDirective } from './directives/bottom-sheet-draggable.directive';
import { PatientStatusGuard } from './guards/patient.status.guard';
import { SummaryStatusGuard } from './guards/summary.status.guard';
import { LegalTermsGuard } from './guards/legal-terms.guard';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { PatientWaitingFormSubmissionGuard } from './guards/patient-waiting-form-submission-guard.service';
import { OrganizationInitGuard } from './guards/organization-init.guard';
import { MariaModule } from './maria/maria.module';
import { SharedPipesModule } from './pipes/shared-pipes.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LocaleTokenGuard } from './guards/locale-token.guard';
import { SiraUiModule } from '@marsaude/sira-components';
import { PatientExamCollectorGuard } from './guards/patient-exam-collector.guard';

@NgModule({
  declarations: [
    FileUploadComponent,
    BottomSheetDraggableDirective,
  ],
  imports: [
    SiraUiModule,
    SharedPipesModule,
    MariaModule,
    NgOptimizedImage,
    RouterModule,
    SharedComponentsModule,
    MatTooltipModule,
    MatIconModule,
    NgxFileDropModule,
    CommonModule,
    FormlyModule,
    MatButtonModule,
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
  ],
  providers: [
    PatientExamCollectorGuard,
    OrganizationInitGuard,
    RoutePartsService,
    PatientWaitingFormSubmissionGuard,
    LegalTermsGuard,
    AuthGuard,
    ConfirmService,
    PatientStatusGuard,
    SummaryStatusGuard,
    LocaleTokenGuard,
  ],
  exports: [
    SiraUiModule,
    SharedPipesModule,
    MariaModule,
    NgOptimizedImage,
    BottomSheetDraggableDirective,
    FileUploadComponent,
    FormlyModule,
  ],
})
export class SharedModule {
}
